import { venueRepository } from "@/service/repository/venueRepository";
import store from "@/store";
import { usePosProviderStore } from "@/stores/posProviderStore";

const MenuOrderStatus = {
	DISABLED: 0,
	ENABLED: 1,
};
export { MenuOrderStatus };

const state = {
	resourceId: null,
	subdomain: null,
	businessName: null,
	venueId: null,
	reservationManagerUrl: null,
	reservationAgent: null,
	menuServices: null,
	disableDay: [],
	weOrderClientComments: false,
	reviewGoogleMapsUrl: "",
	paymentConfig: null,
	copilotMultipleServiceEvent: null,
	locales: [],
	serviceSchedule: [],
	reservationPrePaymentConfig: [] | null,
	fiscalInfo: [] | null,
	reservationLocationTags: [] | null,
	elaborationTypes: [] | null,
	printEnabled: false,
	locationGmapsUrl: null,
	directAccountEnabled: null,
	posProvider: null,
	defaultMenuOrderConfig: {
		cartSendMode: null,
		cartStaffValidation: null,
		description: null,
		menuOrderEnabled: MenuOrderStatus.DISABLED,
		name: null,
		notifyPos: null,
	},
	weOrderConfig: {
		showLargeProductPicture: false,
		weOrderIntegrationEnabled: false,
		weOrderIntegrationMenuUrl: null,
	},
	enableCategoryScroll: true,
	copilotConfig: {
		zoneFilter: false,
		cartProductStaffComments: true,
		weCopilotShowBar: false,
		showPreparationSidebar: false,
		accountShowOrdersBrief: false,
		tableTakeOrderReminder: null,
		tableCleanReminder: null,
		/** 0 = PIN disabled, 1 = PIN enabled + anonymous allowed, 2 = PIN enforced (no anonymous). Default 1 when not provided. */
		pinEntryMode: 1,
		copilotElaborationNewFirst: null,
		copilotElaborationStyle: null,
		copilotElaborationProductOrderGroup: null,
		copilotElaborationProductOrderOptions: null,
		copilotCommanderElaborationOverride: true,
		copilotCommanderPrices: null,
		copilotCommanderStyle: null,
	},
	venueTables: null,
};

const getters = {
	resourceId(state) {
		return state.resourceId;
	},
	urlVenue(state) {
		const subdomain = state.subdomain;
		return `https://${subdomain}.wewelcom.io`;
	},
	businessName(state) {
		return state.businessName;
	},
	venueId(state) {
		return state.venueId;
	},
	locales(state) {
		return state.locales;
	},
	posProvider(state) {
		return state.posProvider;
	},
	reservationManagerUrl(state) {
		return state.reservationManagerUrl;
	},
	reservationAgent(state) {
		return state.reservationAgent;
	},
	menuServices(state) {
		return state.menuServices;
	},
	serviceSchedule(state) {
		return state.serviceSchedule;
	},
	disableDay(state) {
		return state.disableDay;
	},
	weOrderClientComments(state) {
		return state.weOrderClientComments;
	},
	reviewGoogleMapsUrl(state) {
		return state.reviewGoogleMapsUrl;
	},
	paymentConfig(state) {
		return state.paymentConfig;
	},
	copilotMultipleServiceEvent(state) {
		return state.copilotMultipleServiceEvent;
	},
	reservationPrePaymentConfig(state) {
		return state.reservationPrePaymentConfig;
	},
	printEnabled(state) {
		return state.printEnabled;
	},
	fiscalInfo(state) {
		return state.fiscalInfo;
	},
	reservationLocationTags(state) {
		return state.reservationLocationTags;
	},
	elaborationTypes(state) {
		return state.elaborationTypes;
	},
	locationGmapsUrl(state) {
		return state.locationGmapsUrl;
	},
	directAccountEnabled(state) {
		return state.directAccountEnabled;
	},
	defaultMenuOrderConfig(state) {
		return state.defaultMenuOrderConfig;
	},
	weOrderConfig(state) {
		return state.weOrderConfig;
	},
	enableCategoryScroll(state) {
		return state.enableCategoryScroll;
	},
	copilotConfig(state) {
		return state.copilotConfig;
	},
	venueTables(state) {
		return state.venueTables;
	},

	/*cartSendMode(state) {
		return state.defaultMenuOrderConfig.cartSendMode;
	},
	cartStaffValidation(state) {
		return state.defaultMenuOrderConfig.cartStaffValidation;
	},
	description(state) {
		return state.defaultMenuOrderConfig.description;
	},
	menuOrderEnabled(state) {
		return state.defaultMenuOrderConfig.menuOrderEnabled;
	},
	name(state) {
		return state.defaultMenuOrderConfig.name;
	},
	notifyPos(state) {
		return state.defaultMenuOrderConfig.notifyPos;
	},*/
};

const mutations = {
	initConfigVenue(state, payload) {
		// state.welcomTheme = payload.welcom_theme;
		state.subdomain = payload.subdomain;
		state.businessName = payload.business_name;
		state.venueId = payload.id;
		state.reservationManagerUrl = payload.reservationManagerUrl;
		state.resourceId = payload.resource_id;
		state.reservationAgent = payload.reservation_agent;
		state.menuServices = payload.menuServices;
		if (payload.reservation_disabled_dow) {
			state.disableDay.push(payload.reservation_disabled_dow);
		}
		state.weOrderClientComments = payload.we_order_client_comments || false;
		state.reviewGoogleMapsUrl = payload.reviewGoogleMapsUrl || "";
		state.paymentConfig = payload.paymentConfig;
		state.copilotMultipleServiceEvent = payload.copilot_multiple_service_event_product_orders;
		state.locales = payload.locales;
		state.serviceSchedule = payload.serviceSchedule;
		state.reservationPrePaymentConfig = payload.reservationPrePaymentConfig;
		state.printEnabled = payload.printEnabled || false;
		state.fiscalInfo = payload.fiscalInfo;
		state.reservationLocationTags = payload.reservationLocationTags;
		state.elaborationTypes = payload.elaborationTypes;
		state.locationGmapsUrl = payload.location_gmaps_url;
		state.directAccountEnabled = payload.direct_account_enabled;
		state.posProvider = payload.posProvider;
		state.weOrderConfig = payload.weOrderConfig;
		state.defaultMenuOrderConfig = payload.defaultMenuOrderConfig;
		state.copilotConfig = payload.copilotConfig || {
			zoneFilter: false,
			cartProductStaffComments: true,
			weCopilotShowBar: false,
			showPreparationSidebar: false,
			accountShowOrdersBrief: false,
			pinEntryMode: 1,
		};
		// Asegurar que showPreparationSidebar tenga un valor por defecto si no viene en el payload
		if (payload.copilotConfig && payload.copilotConfig.showPreparationSidebar === undefined) {
			state.copilotConfig.showPreparationSidebar = false;
		}
		// Default pinEntryMode to 1 when not provided (pins enabled, anonymous allowed)
		if (state.copilotConfig.pinEntryMode === undefined) {
			state.copilotConfig.pinEntryMode = 1;
		}
		// Default accountShowOrdersBrief to false when not provided
		if (state.copilotConfig.accountShowOrdersBrief === undefined) {
			state.copilotConfig.accountShowOrdersBrief = false;
		}
		if (state.copilotConfig.tableTakeOrderReminder === undefined) {
			state.copilotConfig.tableTakeOrderReminder = null;
		}
		if (state.copilotConfig.tableCleanReminder === undefined) {
			state.copilotConfig.tableCleanReminder = null;
		}
		if (state.copilotConfig.copilotCommanderElaborationOverride === undefined) {
			state.copilotConfig.copilotCommanderElaborationOverride = true;
		}
		store.commit("accounting/setCashDrawers", { cashDrawers: payload.cashDrawers });

		// Update copilot module zoneFilter based on venue config
		store.commit("copilot/setZoneFilterFromVenueConfig", payload);

		// Initialize POS provider store
		try {
			const posProviderStore = usePosProviderStore();
			posProviderStore.initFromVenueConfig(payload);
		} catch (error) {
			console.log("POS provider store not available:", error);
		}
	},
	setElaborationTypes(state, payload) {
		state.elaborationTypes = payload.elaborationTypes;
	},
	setVenueTables(state, tables) {
		state.venueTables = tables;
	},
};

const actions = {
	async loadVenueConfig({ commit }) {
		try {
			const config = await venueRepository.getVenueConfig();
			if (config.result === 0) {
				commit("initConfigVenue", config.venueConfig);
				/*
								if (config.venueConfig.id) {
									const result = await venueRepository.getTables(config.venueConfig.id);
									if (result.status === 200) {
										commit("setVenueTables", result.data);
									}
								}*/
			}
		} catch (err) {
			console.log("Error cargando config venue", err);
			// 🔄 redirect if the sub-domain doesn't exist
			if (err.status === 404 /* && err.data?.error === 'INVALID_VENUE'*/) {
				window.location.replace("https://wewelcom.io");
				return;
			}

			// 🚫 show "suspended" banner / page
			if (err.status === 423 && err.data?.error === "VENUE_SUSPENDED") {
				window.location.replace("https://wewelcom.io");
				return;
			}

			// ❗ any other failure – log & show generic error UI

			console.error("Failed to fetch venue config", err);
			//window.location.replace('https://wewelcom.io');
		}
	},
	async loadElaborationTypes({ commit }) {
		try {
			const getElaborationTypeResult = await venueRepository.getElaborationTypes();
			if (getElaborationTypeResult.result === 0) {
				commit("setElaborationTypes", getElaborationTypeResult.elaborationTypes);
			}
		} catch (error) {
			console.error("Failed to fetch venue elaborationTypes", error);
		}
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
